import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'membership_referral_invite_friends';
export const route = 'membership_referral_invite_friends/[[...referralParams]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershipreferralsenderpage" */
'../../components/MembershipReferralSenderPage')));